
/**
 * Capitalizes a name properly (Title Case)
 * Converts strings like "john doe" or "JOHN DOE" to "John Doe"
 * Note: Custom implementation preferred over lodash.startCase for better handling
 * of all-caps input and special characters like apostrophes
 */
export const capitalizeName = (name: string): string => {
    if (!name || typeof name !== 'string') return name;

    return name
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};